import { render, staticRenderFns } from "./pgaPro.vue?vue&type=template&id=307cec57&scoped=true"
import script from "./pgaPro.vue?vue&type=script&lang=js"
export * from "./pgaPro.vue?vue&type=script&lang=js"
import style0 from "./pgaPro.vue?vue&type=style&index=0&id=307cec57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307cec57",
  null
  
)

export default component.exports